import { render, staticRenderFns } from "./AnimalAliveCell.vue?vue&type=template&id=2e91271c&scoped=true&"
import script from "./AnimalAliveCell.vue?vue&type=script&lang=js&"
export * from "./AnimalAliveCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e91271c",
  null
  
)

export default component.exports